import { render, staticRenderFns } from "./SingleLayerPopupInfos.vue?vue&type=template&id=c209a136&scoped=true"
import script from "./SingleLayerPopupInfos.vue?vue&type=script&lang=ts"
export * from "./SingleLayerPopupInfos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c209a136",
  null
  
)

export default component.exports